'use client';
import styles from './styles.module.css';
import Image from 'next/image';
import { useState } from 'react';

const servicesData = [
  {
    id: 1,
    title: 'Сайты',
    description: 'Создание лендингов и многостраничных сайтов для продвижения продуктов, сбора заявок, презентации услуг и упрощения взаимодействия с клиентами.',
    services: [
      { 
        name: 'Брифинг', 
        duration: '1 день', 
        price: '0 Р', 
        default: true,
        description: 'Вы заполняете бриф, после чего мы созваниваемся и вносим корректировки и уточнения.'
      },
      { 
        name: 'Прототип интерфейса', 
        duration: 'от 2 дней', 
        price: 'от 20 000 Р',
        description: 'Интерактивный макет для проверки сценариев и удобства интерфейса до вёрстки и разработки.'
      },
      { 
        name: 'Дизайн-концепт', 
        duration: 'от 9 дней', 
        price: 'от 15 000 Р',
        description: 'Разработка визуальной концепции и стилистики проекта.'
      },
      { 
        name: 'Дизайн всех страниц', 
        duration: 'от 2 дней', 
        price: 'от 30 000 Р',
        description: 'Создание дизайна всех страниц сайта с учётом удобства и логики интерфейса.'
      },
      { 
        name: 'Мобильная версия', 
        duration: 'от 2 дней', 
        price: 'от 15 000 Р',
        description: 'Адаптация дизайна для мобильных устройств.'
      },
      { 
        name: 'Разработка', 
        duration: 'от 15 дней', 
        price: 'от 40 000 Р',
        description: 'Программирование и техническая реализация проекта.'
      }
    ],
    total: { duration: '30 дней', price: '120 000 Р' }
  },
  {
    id: 2,
    title: 'Интернет-магазины',
    description: 'Создание интернет-магазинов и платформ электронной коммерции.',
    services: [
      { 
        name: 'Брифинг', 
        duration: '1 день', 
        price: '0 Р', 
        default: true,
        description: 'Вы заполняете бриф, после чего мы созваниваемся и вносим корректировки и уточнения.'
      },
      { 
        name: 'Прототип интерфейса', 
        duration: 'от 3 дней', 
        price: 'от 30 000 Р',
        description: 'Интерактивный макет витрины и сценариев покупки для интернет-магазина.'
      },
      { 
        name: 'Дизайн-концепт', 
        duration: 'от 12 дней', 
        price: 'от 90 000 Р',
        description: 'Разработка визуальной концепции интернет-магазина.'
      },
      { 
        name: 'Разработка', 
        duration: 'от 15 дней', 
        price: 'от 120 000 Р',
        description: 'Программирование интернет-магазина с корзиной и оплатой.'
      }
    ],
    total: { duration: '31 дней', price: '240 000 Р' }
  },
  {
    id: 3,
    title: 'Айдентика',
    description: 'Создание фирменного стиля и брендинга.',
    services: [
      { 
        name: 'Брифинг', 
        duration: '1 день', 
        price: '0 Р', 
        default: true,
        description: 'Вы заполняете бриф, после чего мы созваниваемся и вносим корректировки и уточнения.'
      },
      { 
        name: 'Логотип', 
        duration: 'от 5 дней', 
        price: 'от 20 000 Р',
        description: 'Создание уникального логотипа для вашего бренда.'
      },
      { 
        name: 'Фирменный стиль', 
        duration: 'от 10 дней', 
        price: 'от 40 000 Р',
        description: 'Разработка полного фирменного стиля и гайдлайнов.'
      },
      { 
        name: 'Носители', 
        duration: 'от 3 дней', 
        price: 'от 20 000 Р',
        description: 'Адаптация дизайна для различных носителей.'
      }
    ],
    total: { duration: '19 дней', price: '80 000 Р' }
  },
  {
    id: 4,
    title: 'Мини-приложения для Telegram',
    description: 'Разработка мини-приложений для Telegram.',
    services: [
      { 
        name: 'Брифинг', 
        duration: '1 день', 
        price: '0 Р', 
        default: true,
        description: 'Вы заполняете бриф, после чего мы созваниваемся и вносим корректировки и уточнения.'
      },
      { 
        name: 'Прототип интерфейса', 
        duration: 'от 3 дней', 
        price: 'от 30 000 Р',
        description: 'Интерактивный макет экранов мини-приложения до финального дизайна и разработки.'
      },
      { 
        name: 'Дизайн', 
        duration: 'от 12 дней', 
        price: 'от 60 000 Р',
        description: 'Разработка дизайна интерфейса мини-приложения.'
      },
      { 
        name: 'Разработка', 
        duration: 'от 15 дней', 
        price: 'от 120 000 Р',
        description: 'Программирование мини-приложения для Telegram.'
      }
    ],
    total: { duration: '30 дней', price: '210 000 Р' }
  }
];

export default function ServicesSection() {
  const [openService, setOpenService] = useState<number | null>(null);
  const [openItems, setOpenItems] = useState<{ [key: string]: boolean }>({});

  const toggleService = (id: number) => {
    setOpenService(openService === id ? null : id);
  };

  const toggleItem = (serviceId: number, itemIndex: number) => {
    const key = `${serviceId}-${itemIndex}`;
    setOpenItems(prev => ({
      ...prev,
      [key]: !prev[key]
    }));
  };

  return (
    <section id="services" className={styles.servicesSection}>
      <div className={styles.leftBlock}>
        <h2 className={styles.title}>Услуги</h2>
        <h3 className={styles.subtitle}>Кейсы</h3>
      </div>
      
      <div className={styles.rightBlock}>
        <div className={styles.content}>
          {servicesData.map((service) => (
            <div key={service.id} className={styles.serviceItem}>
              <div 
                className={styles.serviceContent}
                onClick={() => toggleService(service.id)}
              >
                <span className={styles.serviceText}>{service.title}</span>
                <Image 
                  src="/assets/icons/plus.svg" 
                  alt="Plus" 
                  width={52} 
                  height={52} 
                  className={`${styles.plusIcon} ${openService === service.id ? styles.rotated : ''}`}
                />
              </div>
              
              <div className={`${styles.dropdown} ${openService === service.id ? styles.open : ''}`}>
                <div className={styles.serviceDescription}>
                  {service.description}
                </div>
                
                <div className={styles.servicesList}>
                  {service.services.map((item, index) => (
                    <div key={index} className={styles.serviceRow}>
                      <div className={styles.serviceInfo}>
                        <span className={styles.serviceName}>{item.name}</span>
                        <span className={styles.serviceDuration}>{item.duration}</span>
                        <span className={styles.servicePrice}>{item.price}</span>
                        <div 
                          className={styles.serviceIcon}
                          onClick={(e) => {
                            e.stopPropagation();
                            toggleItem(service.id, index);
                          }}
                        >
                          <Image 
                            src="/assets/icons/plus.svg" 
                            alt="Plus" 
                            width={20} 
                            height={20} 
                            className={`${styles.smallPlusIcon} ${openItems[`${service.id}-${index}`] ? styles.rotated : ''}`}
                          />
                        </div>
                      </div>
                      
                      <div className={`${styles.itemDescription} ${openItems[`${service.id}-${index}`] ? styles.open : ''}`}>
                        {item.description}
                      </div>
                    </div>
                  ))}
                </div>
                
                <div className={styles.serviceTotal}>
                  <span className={styles.totalDuration}>{service.total.duration}</span>
                  <span className={styles.totalPrice}>{service.total.price}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
} 